module.exports = __webpack_public_path__ + "img/id_step_02@2x.47ae9187.png";